import { render, staticRenderFns } from "./AuditCouponList.vue?vue&type=template&id=48aaeb5d&scoped=true&"
import script from "./AuditCouponList.vue?vue&type=script&lang=ts&"
export * from "./AuditCouponList.vue?vue&type=script&lang=ts&"
import style0 from "./AuditCouponList.vue?vue&type=style&index=0&id=48aaeb5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aaeb5d",
  null
  
)

export default component.exports